import { render, staticRenderFns } from "./option-label-translations-tab.vue?vue&type=template&id=55798422"
import script from "./option-label-translations-tab.vue?vue&type=script&lang=js"
export * from "./option-label-translations-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports